<template>
  <div>
    <div class="login-bg" style="background: #fff">
      <div class="container h-100">
        <div class="row align-items-center h-100">
          <div class="login-wrap col-lg-5 col-sm-6 fl-none">
            <div class="posAbs mt-3">
              <router-link to="/login">
                <a style="color: #000"><i class="fa fa-arrow-left"></i></a>
              </router-link>
            </div>
            <!-- <div class="text-center" style="color: black; font-size: 50px">
              SOS
            </div> -->
            <div class="text-center mt-3">
              <img src="/img/ENTER_OTP.png" alt="" />
            </div>
            <div style="margin-bottom: 18px;color: #DE4A38;" class="forgot-ps pb-0">
              Forgot Password?
            </div>
            <div class="enter-your" style="color: black;">
              Please enter your registered<br />Email.
            </div>
            <Form @submit="forgotPassword()">
              <div class="form-group">
                <Field
                  type="text"
                  name="email"
                  class="inputfield font-weight-bold"
                  placeholder="Registered Email"
                  v-model="email"
                  rules="required:email|email"
                  :validateOnInput="true"
                />
                <ErrorMessage name="email" class="text-danger"/>
              </div>
              <div class="verification mb-4 font-weight-bold" style="color: #DE4A38;">
                We will send verification code on your registered<br />email.
              </div>
              <div class="text-center mb-5">
                <button
                  class="send-btn"
                  id="forgot-password-button"
                >
                  Send
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import {
        Form,
        Field,
        ErrorMessage
    } from "vee-validate";
    export default {
        name: "ForgotPassword",
        components: {
            Form,
            Field,
            ErrorMessage,
        },
        data() {
            return {
                email: "",
            };
        },
        mounted() {},
        methods: {
            forgotPassword() {
                var obj = {
                    email: this.email,
                };
                this.$api
                    .postAPI({
                        _action: "/forgot/password",
                        _body: obj,
                        _buttonId: "forgot-password-button",
                    })
                    .then((res) => {
                        if (res) {
                            localStorage.setItem("email", this.email);
                            this.$router.push("/otp");
                        }
                    })
                    .catch(() => {

                    });
            },
        },
    };
</script>